import { ActionIcon, Table, Text, UnstyledButton, Group, Center } from '@mantine/core';
import { IconEdit, IconChevronUp, IconChevronDown, IconSelector } from '@tabler/icons-react';

interface TranslationsListProps {
	translations: any[];
	onEdit: (translation: any) => void;
	onSortChange: (field: string, direction: string) => void;
	currentSortBy: string;
	currentSortOrder: string;
}

type SortField = 'key' | 'content';

export function TranslationsList({
	translations,
	onEdit,
	onSortChange,
	currentSortBy,
	currentSortOrder
}: TranslationsListProps) {
	const handleSort = (field: SortField) => {
		if (currentSortBy === field) {
			const newDirection = currentSortOrder === 'asc' ? 'desc' : 'asc';
			onSortChange(field, newDirection);
		} else {
			onSortChange(field, 'asc');
		}
	};

	const SortIcon = ({ field }: { field: SortField }) => {
		if (currentSortBy !== field) return <IconSelector size={14} />;
		return currentSortOrder === 'asc' ? <IconChevronUp size={14} /> : <IconChevronDown size={14} />;
	};

	return (
		<Table.ScrollContainer minWidth={700}>
			<Table>
				<Table.Thead>
					<Table.Tr>
						<Table.Th>
							<UnstyledButton onClick={() => handleSort('key')}>
								<Group gap={4}>
									<Text size="sm" fw={600}>
										Key
									</Text>
									<Center>
										<SortIcon field="key" />
									</Center>
								</Group>
							</UnstyledButton>
						</Table.Th>
						<Table.Th>
							<UnstyledButton onClick={() => handleSort('content')}>
								<Group gap={4}>
									<Text size="sm" fw={600}>
										Content (English)
									</Text>
									<Center>
										<SortIcon field="content" />
									</Center>
								</Group>
							</UnstyledButton>
						</Table.Th>
						<Table.Th style={{ width: 100 }}>Actions</Table.Th>
					</Table.Tr>
				</Table.Thead>
				<Table.Tbody>
					{translations.map((translation) => (
						<Table.Tr key={translation.key}>
							<Table.Td>
								<Text size="sm" fw={500}>
									{translation.key}
								</Text>
							</Table.Td>
							<Table.Td>
								<Text size="sm" style={{ maxWidth: 500 }} lineClamp={2}>
									{translation.content}
								</Text>
							</Table.Td>
							<Table.Td>
								<ActionIcon variant="subtle" color="#1A4D66" onClick={() => onEdit(translation)}>
									<IconEdit size={16} />
								</ActionIcon>
							</Table.Td>
						</Table.Tr>
					))}
				</Table.Tbody>
			</Table>
		</Table.ScrollContainer>
	);
}
